<div class="flex flex-wrap py-4 justify-between px-3 rounded-xl bg-gray-100 items-center">
  <div class="flex gap-2 items-center">
    <mat-icon color="primary">{{ icon }}</mat-icon>
    <span class="font-semibold">{{info}}</span>
  </div>
  <ng-content></ng-content>
</div>
